module.exports = __webpack_public_path__ + "img/Card.bed7bc5a.png";